const lang = {
  AA: '阿法爾語',
  AB: '亞布卡薩語',
  AF: '南非荷蘭文',
  AK: '迦納語',
  AM: '阿姆哈拉語',
  AR: '阿拉伯語',
  AN: '阿拉貢語',
  AS: '阿薩姆語',
  AV: '阿瓦爾語',
  AE: '阿維斯語',
  AY: '亞摩拉語',
  AZ: '亞塞拜然語',
  BA: '巴什喀爾語',
  BM: '班巴拉語',
  BE: '白俄羅斯語',
  BN: '孟加拉語',
  BH: '比哈爾語系',
  BI: '比斯拉馬語',
  BO: '藏語',
  BS: '波士尼亞語',
  BR: '布里敦語',
  BG: '保加利亞語',
  CA: '加泰羅尼亞語',
  CS: '捷克語',
  CH: '查莫羅語',
  CE: '車臣語',
  CU: '古教會斯拉夫語',
  CV: '楚瓦什語',
  KW: '康沃爾語',
  CO: '科西嘉語',
  CR: '克里語',
  CY: '威爾斯語',
  DA: '丹麥語',
  DE: '德語',
  DV: '迪維西語',
  DZ: '宗卡語(不丹)',
  EL: '現代希臘語 (1453-)',
  EN: '英文',
  EO: '世界語',
  ET: '愛沙尼亞語',
  EU: '巴斯克語',
  EE: '埃維語',
  FO: '法羅群島語',
  FA: '波斯語',
  FJ: '斐濟語',
  FI: '芬蘭語',
  FR: '法語',
  FY: '西夫里斯蘭語',
  FF: '富拉語',
  GD: '蓋爾語',
  GA: '愛爾蘭語',
  GL: '加里斯亞語',
  GV: '馬恩語',
  GN: '巴拉圭瓜拉尼',
  GU: '古吉拉特語',
  HT: '克里奧爾語(海地)',
  HA: '豪撒語(蘇丹)',
  HE: '希伯來語',
  HZ: '赫雷羅語',
  HI: '印地語(北印度)',
  HO: '希里莫圖語',
  HR: '克羅埃西亞語',
  HU: '匈牙利語',
  HY: '亞美尼亞語',
  IG: '伊布語',
  IO: '伊多語',
  II: '四川彝語',
  IU: '伊努特語',
  IE: '國際語',
  IA: '拉丁國際語',
  ID: '印尼語',
  IK: '依努庇克語',
  IS: '冰島語',
  IT: '義大利語',
  JV: '爪哇語',
  JA: '日語',
  KL: '格陵蘭語',
  KN: '卡納達語',
  KS: '喀什米爾語',
  KA: '喬治亞語',
  KR: '卡努里語',
  KK: '哈薩克語',
  KM: '中央高棉語',
  KI: '基庫尤語',
  RW: '盧安達語',
  KY: '吉爾吉斯語',
  KV: '科米語',
  KG: '剛果語',
  KO: '韓語',
  KJ: '寬亞瑪語',
  KU: '庫德語',
  LO: '老撾語',
  LA: '拉丁語',
  LV: '拉脫維亞語',
  LI: '林堡語',
  LN: '陵加拉語',
  LT: '立陶宛語',
  LB: '盧森堡語',
  LU: '盧巴-加丹加語',
  LG: '干達語',
  MH: '馬紹爾語',
  ML: '馬來亞拉姆語',
  MR: '馬拉提語',
  MK: '馬其頓語',
  MG: '馬達加斯加語',
  MT: '馬爾他語',
  MN: '蒙古語',
  MI: '毛利語',
  MS: '馬來語',
  MY: '緬甸語',
  NA: '諾魯',
  NV: '納瓦霍語',
  NR: '南恩德貝勒語',
  ND: '北恩德貝勒語',
  NG: '恩敦加語',
  NE: '尼泊爾語',
  NL: '荷蘭語',
  NN: '新挪威語',
  NB: '書面挪威語',
  NO: '挪威語',
  NY: '契切瓦語',
  OC: '奧克西坦語 (1500 之後);普羅旺斯語',
  OJ: '奧杰布瓦語',
  OR: '歐利亞語',
  OM: '奧洛莫語',
  OS: '奧塞提語',
  PA: '旁遮普語',
  PI: '巴利語',
  PL: '波蘭語',
  PT: '葡萄牙語',
  PS: '普什圖語',
  QU: '克丘亞語',
  RM: '里托羅曼語',
  RO: '羅馬尼亞語;莫爾達維亞語;摩爾多瓦語',
  RN: '克倫地語',
  RU: '俄羅斯語',
  SG: '桑戈語',
  SA: '梵語',
  SI: '僧加羅語(錫蘭)',
  SK: '斯洛伐克語',
  SL: '斯洛維尼亞語',
  SE: '北薩米語',
  SM: '薩摩亞語',
  SN: '紹納語',
  SD: '信德語',
  SO: '索馬利語',
  ST: '南索托語',
  ES: '西班牙語',
  SQ: '阿爾巴尼亞語',
  SC: '薩丁尼亞語',
  SR: '塞爾維亞語',
  SS: '斯瓦齊語',
  SU: '巽丹語',
  SW: '史瓦西里語',
  SV: '瑞典語',
  TY: '大溪地語',
  TA: '坦米爾語',
  TT: '韃靼語',
  TE: '特拉古語',
  TG: '塔吉克語',
  TL: '塔加拉語',
  TH: '泰語',
  TI: '提格利尼亞語',
  TO: '東加語(東加群島)',
  TN: '茨瓦納語',
  TS: '宋加語',
  TK: '土庫曼語',
  TR: '土耳其語',
  TW: '奇族語',
  UG: '維吾爾語',
  UK: '烏克蘭語',
  UR: '烏爾都語',
  UZ: '烏茲別克語',
  VE: '溫達語',
  VI: '越南語',
  VO: '沃拉普克語',
  WA: '瓦隆語',
  WO: '渥魯夫語',
  XH: '科薩語',
  YI: '意第緒語',
  YO: '約魯巴語',
  ZA: '壯語',
  ZH: '中文',
  ZU: '祖魯語'
};

export default lang;
